import OutlineControls from './OutlineControls';

export default OutlineControls;